export default __webpack_public_path__ + "static/media/txt2_sp.935153a3.png";